import { render } from "./CompanyBankAccountFormDialog.vue?vue&type=template&id=289cd5a2"
import script from "./CompanyBankAccountFormDialog.vue?vue&type=script&lang=js"
export * from "./CompanyBankAccountFormDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__